import { useRef } from 'react';
import { randomId } from '../utils/random-id/random-id.js';

function useId(id) {
  var generateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : randomId;
  var generatedId = useRef(generateId());
  return id || generatedId.current;
}

export { useId };